function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "tra-path-1",
  points: "0 0 33.6637 0 33.6637 24 0 24"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(5.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "tra-mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tra-path-1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M2.0887,14.159 C2.0887,14.159 1.5227,13.912 1.5227,12.743 C1.5227,11.009 2.3717,11.54 2.3717,11.54 L15.7167,19.257 L33.6637,8.885 L33.6637,7.858 L20.4607,0.248 C20.1767,0.071 19.8587,0 19.5397,0 C19.3277,0 19.0797,0.071 18.8677,0.177 L18.6897,0.283 L0.9207,10.549 C0.3897,10.797 -0.0003,11.363 -0.0003,12.885 C-0.0003,14.089 0.6017,15.185 1.5927,15.893 L2.7257,16.531 L15.6817,24 L33.6287,13.629 L33.6287,12.601 L32.8847,12.177 L15.7167,22.017 L2.0887,14.159 Z",
  fill: "#FEFEFE",
  mask: "url(#tra-mask-2)"
})));

var SvgTrainings = function SvgTrainings(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "28px",
    viewBox: "0 0 45 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrainings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trainings.4e03198c.svg";
export { ForwardRef as ReactComponent };